(function () {
    'use strict';

    angular
        .module('webinar')
        .controller('WebinarRequestDetailsController', WebinarRequestDetailsController);

    WebinarRequestDetailsController.$inject = ['$uibModalInstance', 'webinarItem','WebinarService'];

    function WebinarRequestDetailsController($uibModalInstance, webinarItem, WebinarService) {
        var vm = this;

        vm.webinarItem     = webinarItem;
        vm.ok              = ok;
        vm.cancel          = cancel;
        //vm.update          = update;

        activate();

        function activate() {
            //vm.seller = {id:vm.preApprovedItem.seller_id, name:vm.preApprovedItem.seller_name};
            //vm.registered = preApprovedItem.registered;
        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        // function update() {
        //     vm.query['registered']          = vm.registered;
        //     vm.query['seller']              = vm.seller.id;
        //     vm.query['observation']         = vm.preApprovedItem.admin_observation;
        //     vm.query['pre_register_cod']    = vm.preApprovedItem.id;
        //
        //     PhysicalFairService.updatePreApproved(vm.query).then(function(response){
        //         alertify.notify(response.data, 'success', 3);
        //
        //     }).catch(function(err) {
        //         alertify.notify(err, 'danger', 3);
        //     });
        // }

    }

})();